export const drawStatus = {
  LIVE: "LIVE",
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  DRAWN: "DRAWN",
  COMPLETE: "COMPLETE",
};

export const drawStatusMessage = {
  OPEN: "Draw Open",
  CLOSED: "Draw Closed",
  DRAWN: "Draw In Progress",
  COMPLETE: "Draw Closed",
};

export default {
  drawStatus,
  drawStatusMessage,
};
